import { useMutation, UseMutationOptions } from 'react-query';
import {
  forgotPassword,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
} from 'api/authentication';
import { AxiosApiError } from 'api/types';

type UseForgotPassword<TContext = unknown> = Omit<
  UseMutationOptions<
    ForgotPasswordResponse,
    AxiosApiError,
    ForgotPasswordRequest,
    TContext
  >,
  'mutationFn'
>;

export default function useForgotPassword<TContext = unknown>(
  options?: UseForgotPassword<TContext>,
) {
  return useMutation<
    ForgotPasswordResponse,
    AxiosApiError,
    ForgotPasswordRequest,
    TContext
  >(forgotPassword, options);
}
